import script from "./fortrydSletningPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./fortrydSletningPopUp.vue?vue&type=script&setup=true&lang=js"

import "./fortrydSletningPopUp.vue?vue&type=style&index=0&id=6cc00294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc00294"]])

export default __exports__